<template>
  <main>
    <div class="banner">
      <div class="banner__content">

        <img src="~@/assets/images/banner-icons-en.png" width="700px" class="responsive-image" alt="" v-if="this.$i18n.locale == 'en'"/>
        <img src="~@/assets/images/banner-icons-ar.png" width="700px" class="responsive-image" alt="" v-if="this.$i18n.locale == 'ar'"/>

        <h1 class="headline banner__content-headline">{{ bannerContent.title }}</h1>
        <p class="tagline banner__content-desc">{{ bannerContent.content }}</p>
        <router-link :to="{ path: this.$i18n.locale + bannerContent.url }" class="button button--primary">
          <span class="button--primary__text">{{ $t("global.startNewProject") }}</span>
        </router-link>
        <!-- </a> -->
      </div>
    </div>

    <!-- SKILLS -->
    <Skills></Skills>

    <!-- section 2 -->
    <div class="section section-projects align-center" v-bind:style="{ backgroundImage: 'url(' + sectionProjectContent.image_url + ')' }">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-5 col-md-offset-7 col-sm-7 col-sm-offset-5 col-xs-12">
            <div class="section__header m-t-30">
              <h1 class="headline section__header__headline headline-number">{{totalNumberOfProjects}}</h1>
              <h1 class="headline section__header__headline">{{ sectionProjectContent.sub_title }}</h1>
              <p class="tagline section__header__tagline">{{ sectionProjectContent.content }}</p>

              <router-link :to="{ path: this.$i18n.locale + sectionProjectContent.url }" class="button button--primary">
                <span class="button--primary__text">{{ $t("global.checkOurProjects") }}</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- PLANS -->
    <Plans></Plans>

    <!-- CLIENTS -->
    <Clients></Clients>

  </main>
</template>

<script>
import Vue from "vue";
import VueResource from "vue-resource";

import Skills from "./modules/Skills";
import Plans from "./modules/Plans";
import Clients from "./modules/Clients";

Vue.use(VueResource);

export default {
	name: "Homepage",
	data() {
		return {
			pageTitle: "Loading...",
			pageInfo: {},
			bannerContent: {},
			sectionProjectContent: {},
			clients: [],
			totalNumberOfProjects: 0
		};
	},
	components: {
		Skills,
		Plans,
		Clients
	},
	metaInfo() {
		return {
			title: this.pageTitle,
			meta: [
				{ itemprop: "name", content: this.pageInfo.meta_og_description },
				{ itemprop: "description", content: this.pageInfo.meta_og_description },
				{ name: "og:title", content: this.pageInfo.meta_og_title },
				{ name: "og:description", content: this.pageInfo.meta_og_description },
				{ name: "og:url", content: this.pageInfo.meta_url },
				{ name: "og:site_name", content: this.pageInfo.meta_twitter_site },
				{ name: "og:type", content: this.pageInfo.meta_og_type },
				{ name: "og:image", content: this.pageInfo.meta_og_image_url },

				{ name: "twitter:card", content: this.pageInfo.meta_twitter_card },
				{ name: "twitter:site", content: this.pageInfo.meta_twitter_site },
				{ name: "twitter:title", content: this.pageInfo.meta_twitter_title },
				{
					name: "twitter:description",
					content: this.pageInfo.meta_twitter_description
				},
				{
					name: "twitter:creator",
					content: this.pageInfo.meta_twitter_creator
				},
				{ name: "twitter:image", content: this.pageInfo.meta_twitter_image_url }
			]
		};
	},
	created() {
		this.getPageInfo();
		this.getAll();
	},
	methods: {
		getPageInfo() {
			this.$http
				.get(this.$parent.$parent.apiURL + "/Pages?id=7")
				.then(function(response) {
					this.pageInfo = response.body;
					this.pageTitle = this.pageInfo.title;
				});
		},
		getAll() {
			this.$http
				.get(
					this.$parent.$parent.apiURL +
						"/textblocks/text-blocks-widgets?filter[name]=homepage-section-banner"
				)
				.then(function(response) {
					this.bannerContent = response.body.widget_blocks[0];
				});
			this.$http
				.get(
					this.$parent.$parent.apiURL +
						"/textblocks/text-blocks-widgets?filter[name]=homepage-section-projects"
				)
				.then(function(response) {
					this.sectionProjectContent = response.body.widget_blocks[0];
					this.totalNumberOfProjects = this.sectionProjectContent.title;
				});
		}
	}
};
</script>

<style scoped>
@media (min-width: 46.25em) {
	.banner {
		background: url(~@/assets/images/homepage-banner-dimmed.png);
		background-repeat: no-repeat;
		background-position: center 0%;
		background-size: 100%;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Homepage.vue